<section id="contact">
  <div class="container">
    <div class="cta-glass text-center" appReveal>
      <h2>{{ title }}</h2>
      <p>{{ subtitle }}</p>
      <div class="cta-btns d-flex gap-3 justify-content-center flex-wrap mb-4">
        <a class="btn-primary" [routerLink]="['/']" [fragment]="'pricing'">Ver planes</a>
        <a class="btn-wa d-inline-flex align-items-center gap-2"
           [href]="'https://wa.me/' + contact.whatsappNumber" target="_blank" rel="noopener">
          <fa-icon [icon]="faWhatsapp"></fa-icon>
          {{ contact.whatsappDisplay }}
        </a>
      </div>
      @if (showAppBadges) {
        <div class="app-row d-flex gap-2 justify-content-center flex-wrap">
          <a class="app-badge d-inline-flex align-items-center gap-2" [href]="appLinks.ios" target="_blank" rel="noopener noreferrer" aria-label="Descargar en App Store">
            <fa-icon [icon]="faApple"></fa-icon>
            App Store
          </a>
          <a class="app-badge d-inline-flex align-items-center gap-2" [href]="appLinks.android" target="_blank" rel="noopener noreferrer" aria-label="Descargar en Google Play">
            <fa-icon [icon]="faGooglePlay"></fa-icon>
            Google Play
          </a>
          <a class="app-badge d-inline-flex align-items-center gap-2" [href]="appLinks.appGallery" target="_blank" rel="noopener noreferrer" aria-label="Descargar en AppGallery">
            <fa-icon [icon]="faMobileScreen"></fa-icon>
            AppGallery
          </a>
        </div>
      }
    </div>
  </div>
</section>
